import request from '@/utils/request';
import * as types from '@/api/org/types';
import { reqCatch, type ReqReturn } from '@/utils/catch';
import { getGroupMembers, getEnterpriseMembers } from './depend';
import { AC_NEW_URL } from '@/constant/keys';
export function createOrg(data: types.createGroupReqType): Promise<any> {
  return request({
    url: `/api/v2/groups`,
    method: 'post',
    data
  });
}

export function getOrg(params: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request(
    {
      url: `/api/v2/groups/${params.orgId}`,
      method: 'get',
      params
    },
    { customError: true }
  );
}

// 组织详情-带权限-返回审核 audit_fields 字段，仅在组织设置页调用
export function getOrgDetailWithAudit(params: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/groups/${params.orgId}/audit_info`,
    method: 'get',
    params
  });
}

// 获取/搜索组织
export function getOrgs(params: types.commonGroupReqType): Promise<ReqReturn<types.commonGroupResType>> {
  return reqCatch(() =>
    request({
      url: `/api/v2/groups`,
      method: 'get',
      params
    })
  );
}

export function setOrg(data: types.createGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/groups/${data.orgId}/risk`,
    method: 'put',
    data
  });
}

export function setOrgSimple(data: types.createGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/groups/${data.orgId}`,
    method: 'put',
    data
  });
}
export function updateOrg(data: types.createGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/groups/${data.orgId}/risk`,
    method: 'put',
    data
  });
}
export function deleteOrg(data: types.createGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/groups/${data.orgId}`,
    method: 'delete'
  });
}

// 查询登录用户是否关注某组织
export function checkHasFollowed(data: types.createGroupReqType): Promise<types.commonGroupResType> {
  return request(
    {
      url: '/api/v1/follow/hasFollowed',
      method: 'get',
      params: data
    },
    {
      customError: true
    }
  );
}

// 获取组织下所有项目
export function getOrgProjectList(data: types.createGroupReqType): Promise<types.commonGroupResType> {
  return request(
    {
      url: `/api/v2/groups/${data.orgId}/projects`,
      method: 'get',
      params: data
    },
    {
      customError: true
    }
  );
}

// 获取组织下项目统计数
export function getOrgProjectStatistics(data: types.createGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/groups/${data.orgId}/statistical/project_total`,
    method: 'get',
    params: data
  });
}

// 查询组织项目精选
export function getOrgHandpickProjectList(data: types.createGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/projects/featured/${data.type}`,
    method: 'get',
    params: data
  });
}

// 项目精选重排序
export function reorderSelectedItems(data: types.createGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/projects/featured/${data.type}/resort`,
    method: 'put',
    data
  });
}

// 查询组织path是否重复
export function inquireOrgPathIsRepeat(data: types.createGroupReqType): Promise<types.commonGroupResType> {
  return request(
    {
      url: `/api/v2/groups/path_suggestion`,
      method: 'get',
      params: data
    },
    { customError: true }
  );
}

// 组织讨论设置回显
export function getOrgDiscussionSettings(data: types.createGroupReqType): Promise<types.commonGroupResType> {
  return request(
    {
      url: `/api/v2/groups/${data.orgId}/module/setting`,
      method: 'get',
      params: data
    },
    {
      customError: true
    }
  );
}

// 组织讨论设置保存
export function saveOrgDiscussionSettings(data: types.createGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/groups/${data.orgId}/module/setting`,
    method: 'put',
    data
  });
}

// 获取组织语言
export function getOrgLanguages(data: types.createGroupReqType): Promise<types.commonGroupResType> {
  return request(
    {
      url: `/api/v2/groups/${data.orgId}/languages`,
      method: 'get',
      params: data
    },
    {
      customError: true
    }
  );
}

// 获取组织topic列表
export function getOrgTopics(data: types.createGroupReqType): Promise<types.commonGroupResType> {
  return request(
    {
      url: `/api/v2/groups/${data.orgId}/tags`,
      method: 'get',
      params: data
    },
    {
      customError: true
    }
  );
}

// 查询组织首页运营内容
export function getOrgOperationContent(data: types.createGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v1/devpress/group/${data.orgId}/home_operation`,
    method: 'get',
    params: data
  });
}

// 判断是否绑定csdn账号
export function isBindCsdnCount(data: types.createGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v1/user/csdn-identity`,
    method: 'get',
    params: data
  });
}

// 申请社区
export function applicantCommunity(data: types.createGroupReqType): Promise<any> {
  return request({
    url: `/api/v1/devpress/${data.orgId}`,
    method: 'post',
    data
  });
}

// 注销社区
export function deleteCommunity(data: types.createGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v1/devpress/${data.orgId}`,
    method: 'delete'
  });
}

// 社区基本信息
export function getCommunityInfo(data: types.createGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v1/devpress/${data.orgId}/info`,
    method: 'get'
  });
}

// 转移组织
export function transferOrg(data: types.createGroupReqType): Promise<any> {
  return request({
    url: `/api/v4/groups/${data.orgId}/transfer`,
    method: 'post',
    data
  });
}

// 判断用户是否能创建组织
export function checkUserCreateOrg(data: types.createGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/groups/quota`,
    method: 'get',
    params: data
  });
}

export function getOrgMemberList(data: types.createGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/ac/groups/${data.orgId}/group-members`,
    method: 'get'
  });
}
/** 组织邀请成员 */
export function createInvite(data: { group_id: string; conf: Record<string, any> }) {
  const { group_id, conf } = data;
  return reqCatch(() =>
    request({
      url: `${AC_NEW_URL}/invitation/${group_id}/invite`,
      method: 'post',
      data: {
        ...conf,
        source_type: '0'
      }
    })
  );
}
// 企业邀请成员
export function createEnterpriseInvite(data: { enterprise_id: string; conf: Record<string, any> }) {
  const { enterprise_id, conf } = data;
  return reqCatch(() =>
    request({
      url: `/api/v2/enterprises/${enterprise_id}/enterprise-members`,
      method: 'post',
      data: {
        ...conf,
        source_type: '1'
      }
    })
  );
}
export function checkInvite(data: types.createGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `${AC_NEW_URL}/invitation/check`,
    method: 'get',
    params: data
  });
}

export function acceptInvite(token: string) {
  return request({
    url: `${AC_NEW_URL}/invitation/members/${token}/accept`,
    method: 'put'
  });
}

export function revokeInvite(token: string): Promise<types.commonGroupResType> {
  return request({
    url: `${AC_NEW_URL}/invitation/members/${token}/revoke`,
    method: 'delete'
  });
}

/** 获取组织下的待邀请成员 */
export function getMembersInvite(data: { group_id: string; page: number; per_page: number }) {
  return reqCatch(() =>
    request({
      url: `${AC_NEW_URL}/groups/${data.group_id}/members/invite`,
      method: 'get',
      params: data
    })
  );
}

/** 移除组织内的用户 */
export function removeGroupUser(data: { group_id: string; username: string }) {
  const { group_id, username } = data;
  return reqCatch(() =>
    request({
      url: `/api/v1/groups/${group_id}/members/${username}`,
      method: 'delete'
    })
  );
}

// 成员管理移除企业成员
export function removeEnterpriseMembers(data: { enterprise_id: string; username: string }) {
  const { enterprise_id, username } = data;
  return reqCatch(() =>
    request({
      url: `/api/v2/enterprises/${enterprise_id}/enterprise-members/${username}`,
      method: 'delete'
    })
  );
}

/** 撤销组织中的成员邀请 */
export function retractGroupInvite(data: { group_id: string; username: string }) {
  const { group_id, username } = data;
  return reqCatch(() =>
    request({
      url: `${AC_NEW_URL}/invitation/${group_id}/0/members/${username}/revoke`,
      method: 'delete'
    })
  );
}

/** 退出当前组织 */
export function exitGroup(data: { group_id: string }) {
  const { group_id } = data;
  return reqCatch(() =>
    request({
      url: `/api/v1/groups/${group_id}/leave`,
      method: 'delete'
    })
  );
}

/** 设置组织中成员的权限 */
export function setGroupUserLevel(data: {
  group_id: string;
  username: string;
  access_level: string;
  role_uuid: string;
}) {
  const { group_id, username, access_level, role_uuid } = data;
  return reqCatch(() =>
    request({
      url: `/api/v1/groups/${group_id}/members/${username}`,
      method: 'put',
      data: { access_level, role_uuid }
    })
  );
}
// 修改企业中成员角色
export function setEnterpriseMemberLevel(data: {
  enterprise_id: string;
  username: string;
  access_level: string;
  role_uuid: string;
  expires_at?: string;
}) {
  const { enterprise_id, username, access_level, role_uuid, expires_at } = data;
  return reqCatch(() =>
    request({
      url: `/api/v2/enterprises/${enterprise_id}/enterprise-members/${username}`,
      method: 'put',
      data: { access_level, role_uuid, expires_at }
    })
  );
}
// 修改企业成员别名+企业邮箱
export function setEnterpriseMemberAlias(data: {
  enterprise_id: string;
  username: string;
  enterprise_name: string;
  enterprise_email?: string | null;
  no_enterprise_email?: boolean;
}) {
  const { enterprise_id, username, enterprise_name, enterprise_email = '', no_enterprise_email = false } = data;
  return reqCatch(() =>
    request({
      url: `/api/v2/enterprises/${enterprise_id}/enterprise-members/user/${username}`,
      method: 'put',
      data: {
        enterprise_user_name: enterprise_name,
        ...(!no_enterprise_email && { enterprise_email })
      }
    })
  );
}

/** 更新组织中成员的角色 */
export function changeGroupMembers(data: { groupId: string; memberId: string; roleId: string | number }) {
  const { groupId, memberId, roleId } = data;
  return reqCatch(() =>
    request({
      url: `/api/v2/ac/groups/${groupId}/group-members/${memberId}`,
      method: 'put',
      params: { roleId }
    })
  );
}

/** 精准搜索匹配组织中的成员 */
export function toSearchGroupMember(group_id: string, username: string) {
  return reqCatch(() =>
    request({
      url: `/api/v1/groups/${group_id}/members/${username}`
    })
  );
}

/* 查询path是个人还是组织 */
export function getPathType(params: types.createGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: '/api/v2/groups/path_type',
    method: 'get',
    params
  });
}

/** 获取用量以及存储相关 */
export function getOrgStock(group_id: string) {
  return reqCatch(() =>
    request({
      url: `/api/v1/namespaces/${group_id}/statistic`
    })
  );
}

/** 创建成员邀请链接 **/
export function createGroupMemberLink(data: { namespace: string } & types.MemberInviteLinkProps) {
  const { namespace, ...config } = data;
  return reqCatch(() =>
    request({
      url: `${AC_NEW_URL}/enterprises/${namespace}/invite/link`,
      method: 'post',
      data: config
    })
  );
}
/** 删除成员邀请链接 */
export function deleteMemberInviteLink(namespace: string, inviteId: string) {
  return reqCatch(() =>
    request({
      url: `${AC_NEW_URL}/enterprises/${namespace}/${inviteId}/invite/link`,
      method: 'delete'
    })
  );
}
/** 查询成员邀请链接列表 */
export function getMemberInviteLinks(params: {
  namespace: string;
  page?: number;
  per_page?: number;
  source_type?: string;
  enterprise_id?: string;
}) {
  const { namespace, ...pager } = params;
  return reqCatch(() =>
    request({
      url: `${AC_NEW_URL}/enterprises/${namespace}/invite/link`,
      method: 'get',
      params: Object.assign({ page: 1, per_page: 10 }, pager)
    })
  );
}
/** 修改成员邀请链接 **/
export function updateGroupMemberLink(data: { namespace: string; inviteId: string } & types.MemberInviteLinkProps) {
  const { namespace, inviteId, ...config } = data;
  return reqCatch(() =>
    request({
      url: `${AC_NEW_URL}/enterprises/${namespace}/${inviteId}/invite/link`,
      method: 'put',
      data: config
    })
  );
}
/** 接受邀请链接 */
export function acceptGroupInvite(invite_code: string) {
  return reqCatch(() =>
    request({
      url: `${AC_NEW_URL}/${invite_code}/invite/accept`
    })
  );
}
/** 查看邀请链接待接受成员列表 */
export function getAcceptGroupMember(params: {
  namespace: string;
  page?: number;
  per_page?: number;
  source_type?: string;
  enterprise_id?: string;
}) {
  const { namespace, ...pager } = params;
  return reqCatch(() =>
    request({
      url: `${AC_NEW_URL}/enterprises/${namespace}/invite/accept/member`,
      params: Object.assign({ page: 1, per_page: 10 }, pager)
    })
  );
}
/** 审核链接访问的成员 */
export function checkGroupLinkMember(data: {
  namespace: string;
  id: number;
  access_level: string;
  member_expires_at?: string;
  audit: '0' | '2';
}) {
  const { namespace, id, ...conf } = data;
  return reqCatch(() =>
    request({
      url: `${AC_NEW_URL}/enterprises/${namespace}/${id}/invite/audit`,
      method: 'put',
      data: conf
    })
  );
}
/** 删除链接访问的成员 */
export function removeGroupLinkMember(namespace: string, id: number) {
  return reqCatch(() =>
    request({
      url: `${AC_NEW_URL}/enterprises/${namespace}/${id}/invite/audit`,
      method: 'delete'
    })
  );
}

/** 模糊搜索匹配相关组织 */
export function getFuzzyGroups(params: {
  name?: string;
  path?: string;
  description?: string;
  page?: number;
  per_page?: number;
  orderBy?: 'name' | 'path' | 'id' | 'created_at' | 'updated_at';
  sort: 'asc' | 'desc';
}) {
  const { page, per_page, ...param } = params;
  return reqCatch(() =>
    request({
      url: '/api/v2/groups/search/list',
      params: { ...param, ...Object.assign({ page: 1, per_page: 10 }, { page, per_page }) }
    })
  );
}

// 新建CLA协议
export function claAdd(data: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/cla/${data.orgId}/add`,
    method: 'post',
    data
  });
}

// 编辑CLA协议
export function claUpdate(data: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/cla/${data.orgId}/update`,
    method: 'put',
    data
  });
}

// 获取CLA协议详情
export function claDetail(params: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/cla/detail`,
    method: 'get',
    params
  });
}
/* 组织webhooks对应接口开始 */
/** 获取项目分支webhook */
export function getRepoWebhooks(params: { repoId: string | null; conf: Record<string, any> }) {
  return reqCatch(
    () =>
      request({
        url: `/api/v2/groups/${params.repoId}/hooks`,
        params: params.conf
      }),
    params
  );
}
/** 新增webhook配置 */
export function createWebhook(data: { repoId: string | number | null; conf: Record<string, any> }) {
  return reqCatch(
    () =>
      request(
        {
          url: `/api/v2/groups/${data.repoId}/hooks`,
          data: data.conf,
          method: 'post'
        },
        {
          customError: true
        }
      ),
    data
  );
}
/** 编辑webhook */
export function editWebhook(data: { repoId: string | null; hook_id: string; conf: Record<string, any> }) {
  const { repoId, hook_id, conf } = data;
  return reqCatch(() =>
    request({
      url: `/api/v2/groups/${repoId}/hooks/${hook_id}`,
      method: 'put',
      data: conf
    })
  );
}
/** 获取webhook详情 */
export function getWebhookDetail(data: { repoId: string | null; hook_id: string }) {
  const { repoId, hook_id } = data;
  return reqCatch(() =>
    request({
      url: `/api/v2/groups/${repoId}/hooks/${hook_id}`
    })
  );
}
/** 获取webhook请求日志 */
export function getWebhookLogs(data: { repoId: string | null; hook_id: string; page?: number; per_page?: number }) {
  const { repoId, hook_id, ...param } = data;
  return reqCatch(() =>
    request({
      url: `/api/v2/groups/${repoId}/hooks/${hook_id}/logs`,
      params: Object.assign({ page: 1, per_page: 10 }, param)
    })
  );
}
/** 获取项目webhook日志详情 */
export function getWebhookLogDetail(data: { repoId: string | null; hook_id: string; id: string }) {
  const { repoId, hook_id, id } = data;
  return reqCatch(() =>
    request({
      url: `/api/v2/groups/${repoId}/hooks/${hook_id}/logs/${id}`
    })
  );
}
/** 删除webhook */
export function deleteWebHook(data: { repoId: string | null; hook_id: string }) {
  const { repoId, hook_id } = data;
  return reqCatch(() =>
    request({
      url: `/api/v2/groups/${repoId}/hooks/${hook_id}`,
      method: 'delete'
    })
  );
}
/* 组织webhooks对应接口结束 */

/** 获取组织默认设置 */
export function getOrgDefaultSetting(params: { group_id: string }) {
  return reqCatch(() =>
    request({
      url: `/api/v2/groups/${params.group_id}`,
      method: 'get'
    })
  );
}

/** 更新组织默认设置 */
export function updateOrgDefaultSetting(data: types.commonGroupReqType) {
  const { group_id } = data;
  delete data.group_id;
  return reqCatch(() =>
    request({
      url: `/api/v2/groups/${group_id}/ext/setting`,
      method: 'put',
      data
    })
  );
}

// 获取组织设置角色列表
export async function getOrgGroupsRolesList(groupId: string): Promise<types.commonGroupResType> {
  // const orgStore = orgInfoStore();
  // await orgStore.updateSourceInfo();
  const orgId = groupId; // || orgStore.orgInfo.id;

  return request({
    url: `/api/v2/ac/groups/${orgId}/roles`,
    method: 'get'
  });
}
// 获取企业设置角色列表
export async function getEnterPriseGroupsRolesList(groupId: string): Promise<types.commonGroupResType> {
  const enterprise_id = groupId;
  return request({
    url: `/api/v2/enterprises/${enterprise_id}/roles`,
    method: 'get'
  });
}

/**
 * 校验组织设置角色名字是否合法,不允许重复
 * @param params
 * @returns
 */
export function checkOrgRolesName(params: { groupId: string; roleName: string }) {
  return request({
    url: `/api/v2/ac/groups/${params.groupId}/custom-roles/check-name`,
    method: 'get',
    params: { roleName: params.roleName }
  });
}

/**
 * 校验企业设置角色名字是否合法,不允许重复
 * @param params
 * @returns
 */
export function checkEnterpriseRolesName(params: { sourceId: string; roleName: string }) {
  return request({
    url: `/api/v2/enterprises/${params.sourceId}/custom-roles/check-name`,
    method: 'get',
    params: { roleName: params.roleName }
  });
}

/**
 * 获取组织所有自定义角色及对应权限点
 * @param params
 * @returns
 */
export function getOrgAllCustomRoles(groupId: string) {
  return request({
    url: `/api/v2/ac/groups/${groupId}/custom-roles`,
    method: 'get'
  });
}
/**
 *  获取企业所有自定义角色及对应权限点
 * @param params
 * @returns
 */
export function getEnterpriseAllCustomRoles(enterprise_id: string) {
  return request({
    url: `/api/v2/enterprises/${enterprise_id}/custom-roles`,
    method: 'get'
  });
}

/**
 * 获取组织指定角色及对应权限点
 * @param params
 * @returns
 */
export function getOrgCustomRoles(groupId: string, roleId: string) {
  return request({
    url: `/api/v2/ac/groups/${groupId}/permissions/${roleId}`,
    method: 'get'
  });
}
/**
 * 获取企业指定角色及对应权限点
 * @param params
 * @returns
 */
export function getEnterpriseCustomRoles(enterprise_id: string, role_uuid: string) {
  return request({
    url: `/api/v2/enterprises/${enterprise_id}/permissions/${role_uuid}`,
    method: 'get'
  });
}

/**
 * 获取组织所有自定义角色及对应权限点
 * @param params
 * @returns
 */
export function addOrgCustomRoles(groupId: string, data: any) {
  return request({
    url: `/api/v2/ac/groups/${groupId}/custom-roles`,
    method: 'post',
    data
  });
}
/**
 * 添加企业所有自定义角色及对应权限点
 * @param params
 * @returns
 */
export function addEnterpriseCustomRoles(enterprise_id: string, data: any) {
  return request({
    url: `/api/v2/enterprises/${enterprise_id}/custom-roles`,
    method: 'post',
    data
  });
}

/**
 * 编辑组织所有自定义角色,基础信息
 * @param params
 * @returns
 */
export function editOrgCustomRoles(param: { orgId: string; roleId: string; data: any }) {
  return request({
    url: `/api/v2/ac/groups/${param.orgId}/custom-roles/${param.roleId}`,
    method: 'put',
    data: param.data
  });
}
/**
 * 编辑企业所有自定义角色,基础信息
 * @param params
 * @returns
 */
export function editEnterpriseCustomRoles(param: { enterprise_id: string; role_uuid: string; data: any }) {
  return request({
    url: `/api/v2/enterprises/${param.enterprise_id}/custom-roles/${param.role_uuid}`,
    method: 'put',
    data: param.data
  });
}

// 保存权限信息
export function editOrgPermissionCustomRoles(param: { orgId: string; roleId: string; data: any }) {
  return request({
    url: `/api/v2/ac/groups/${param.orgId}/permissions/${param.roleId}`,
    method: 'put',
    data: param.data
  });
}

// 保存企业权限信息
export function editEnterprisePermissionCustomRoles(param: { enterprise_id: string; role_uuid: string; data: any }) {
  return request({
    url: `/api/v2/enterprises/${param.enterprise_id}/permissions/${param.role_uuid}`,
    method: 'put',
    data: param.data
  });
}

/**
 * 删除组织指定角色及对应权限点
 * @param params
 * @returns
 */
export function deleteOrgCustomRoles(param: { orgId: string; roleId: string }) {
  return request({
    url: `/api/v2/ac/groups/${param.orgId}/custom-roles/${param.roleId}`,
    method: 'delete'
  });
}
/**
 * 删除企业指定角色及对应权限点
 * @param params
 * @returns
 */
export function deleteEnterpriseCustomRoles(param: { enterprise_id: string; role_uuid: string }) {
  return request({
    url: `/api/v2/enterprises/${param.enterprise_id}/custom-roles/${param.role_uuid}`,
    method: 'delete'
  });
}

// 获取看板白名单组织列表
export function getOrgKanbanWhiteList(params: { org_paths: string /* 支持多个 英文逗号分割 */ }) {
  return reqCatch(() =>
    request({
      url: `/api/v1/kanban/is_white_orgs`,
      method: 'get',
      params
    })
  );
}

// 获取组织公告分类ID
export async function getAnnouncementId(params: { source_id: number | string; category_type: number }) {
  return reqCatch(() =>
    request({
      url: `/api/v1/discuss/category/type/oldObject`,
      method: 'get',
      params
    })
  );
}

// 获取组织readme
export function getOrgReadme(group_id: string) {
  return reqCatch(() =>
    request({
      url: `/api/v2/groups/${group_id}/readme/file`,
      method: 'get'
    })
  );
}

// 添加邀请成员的白名单
export function addWhiteList(group_id: string, data: Array<string>) {
  return reqCatch(() =>
    request({
      url: `${AC_NEW_URL}/${group_id}/invite/white-list`,
      method: 'post',
      data
    })
  );
}

// 审批白名单中的人员
export function approveWhiteList(group_id: number | string) {
  return reqCatch(() =>
    request({
      url: `${AC_NEW_URL}/${group_id}/invite/white-list/approve`,
      method: 'post'
    })
  );
}
// 认领组织
export function bindThirdClaimGroup(params: any): Promise<any> {
  return reqCatch(
    () =>
      request({
        url: '/api/v1/groups/third/claim-group',
        method: 'post',
        params
      }),
    params
  );
}

// 组织主页模块用户自定义配置
export function orgShowSetting(params: any): Promise<any> {
  return request({
    url: `/api/v2/groups/${params.group_id}/show_setting`,
    method: 'put',
    data: params
  });
}

// 设置组织社区动态获取条件（全部或未关闭）
export function orgDynamicSetting(data: any): Promise<any> {
  return request({
    url: `/api/v2/groups/${data.group_id}/dynamic_show_mode`,
    method: 'put',
    data
  });
}

// 查询是否是组织归属企业的企业成员
export function getMemberByEnterprise(params: { enterpriseId: string }) {
  return reqCatch(() =>
    request(
      {
        url: `/api/v2/ac/auth/enterprises/${params.enterpriseId}`,
        method: 'get'
      },
      {
        customError: true
      }
    )
  );
}

// 获取组织合集列表
export function getOrgCollections(params: any) {
  return reqCatch(() =>
    request({
      url: `/aihub/api/v1/collection/group/list`,
      method: 'get',
      params
    })
  );
}

export { getGroupMembers, getEnterpriseMembers };

// ------------------------- 企业里程碑  start -----------------------------//

/**
 * 获取企业里程碑列表
 * @param enterprise_id 企业 id
 * @returns
 */
export function getEnterpriseMilestones(params: any) {
  const { enterprise_id, ...rest } = params;
  return reqCatch(() =>
    request({
      url: `/issuepr/api/v1/enterprises/${enterprise_id}/milestones`,
      method: 'get',
      params: rest
    })
  );
}

/**
 * 创建企业里程碑
 * @param data
 * @returns
 */
export function createEnterpriseMilestone(data: any) {
  const { enterprise_id, ...rest } = data;
  return reqCatch(() =>
    request({
      url: `/issuepr/api/v1/enterprises/${enterprise_id}/milestones`,
      method: 'post',
      data: rest
    })
  );
}

/**
 * 查询企业里程碑锁状态 - 判断上一次关联是否执行完成
 * @param data
 * @returns
 */
export function checkEnterpriseMilestoneLockStatus(data: { enterprise_id: string; id: string }) {
  const { enterprise_id, id } = data;
  return reqCatch(() =>
    request({
      url: `/issuepr/api/v1/enterprises/${enterprise_id}/milestones/${id}/lock_status`,
      method: 'get'
    })
  );
}

/**
 * 编辑企业里程碑
 * @param data
 * @returns
 */
export function editEnterpriseMilestone(data: any) {
  const { enterprise_id, id, ...rest } = data;
  return reqCatch(() =>
    request({
      url: `/issuepr/api/v1/enterprises/${enterprise_id}/milestones/${id}`,
      method: 'put',
      data: rest
    })
  );
}

/**
 * 获取企业里程碑详情
 * @param data
 * @returns
 */
export function enterpriseMilestoneDetail(data: { enterprise_id: string; id: string }) {
  const { enterprise_id, id } = data;
  return reqCatch(() =>
    request({
      url: `/issuepr/api/v1/enterprises/${enterprise_id}/milestones/${id}`,
      method: 'get'
    })
  );
}

/**
 * 删除企业里程碑
 * @param data
 * @returns
 */
export function deletedEnterpriseMilestone(data: { enterprise_id: string; id: string }) {
  const { enterprise_id, id } = data;
  return reqCatch(() =>
    request({
      url: `/issuepr/api/v1/enterprises/${enterprise_id}/milestones/${id}`,
      method: 'delete'
    })
  );
}

/**
 * 获取企业可关联的repo
 * @param data
 * @returns
 */
export function repoRelatedToEnterprise(data: { enterprise_id: string }) {
  const { enterprise_id } = data;
  return reqCatch(() =>
    request({
      url: `/api/v2/enterprises/${enterprise_id}/group/projects`,
      method: 'get'
    })
  );
}

/**
 * 获取企业里程碑关联的pr
 * @param data
 * @returns
 */
export function enterpriseMilestoneRelatedPrs(params: any) {
  const { enterprise_id, ...rest } = params;
  return reqCatch(() =>
    request({
      url: `/issuepr/api/v1/enterprises/${enterprise_id}/merge_requests`,
      method: 'get',
      params: rest
    })
  );
}

/**
 * 获取企业里程碑关联的pr，不同状态的 pr 数量 - 废弃
 * @param data
 * @returns
 */
export function enterpriseMilestoneRelatedPrsCount(params: any) {
  const { enterprise_id, ...rest } = params;
  return reqCatch(() =>
    request({
      url: `/issuepr/api/v1/enterprises/${enterprise_id}/merge_requests/count`,
      method: 'get',
      params: rest
    })
  );
}

/**
 * 获取企业里程碑关联的issue
 * @param data
 * @returns
 */
export function enterpriseMilestoneRelatedIssues(data: any) {
  const { enterprise_id, milestone_id, ...rest } = data;
  return reqCatch(() =>
    request({
      url: `/issuepr/api/v1/enterprises/${enterprise_id}/milestones/${milestone_id}/issues`,
      method: 'get',
      params: rest
    })
  );
}

// ------------------------- 企业里程碑  end -----------------------------//
/**
 * 导出企业 issue 列表，创建任务
 * @param data
 * @returns
 */
export function exportEnterpriseIssueList(data: any) {
  const { enterprise_id, ...rest } = data;
  return reqCatch(() =>
    request({
      url: `/issuepr/api/v1/projects/enterprises/${enterprise_id}/issues_export`,
      method: 'post',
      data: rest
    })
  );
}
